module.exports = __webpack_public_path__ + "img/problem-top-mobile.da2d602b.png";